import React, { useEffect, useState } from 'react'
import Page from '../../../../component/Page'
import TitlePage from '../../../../component/TitlePage'
import AddButton from '../../../../component/AddButton'
import { Box, Button, FormControl, MenuItem, Pagination, Select, Skeleton } from '@mui/material'
import { useSelector } from 'react-redux'
import { Link, useSearchParams } from 'react-router-dom'
import { getBranchList, getRawSeedMovementsList } from '../../services/api'
import InputSearch from '../../../../component/InputSearch'
import dayjs from 'dayjs'

export default function StockRawList() {
    const [branchs, setBranchs] = useState([])
    const [loading, setLoading] = useState(false)

    const { profile } = useSelector(state => state.profile)

    const [searchParams, setSearchParams] = useSearchParams()
    let id = searchParams.get('id') || ''
    let q = searchParams.get('q') || ''
    let b = searchParams.get('b') || ''
    let page = searchParams.get('page') || '1'
    const [data, setData] = useState([])
    const [rowsPerPage] = useState(10);

    useEffect(() => {
        const getList = async () => {
            setLoading(true)
            const data = await getRawSeedMovementsList(q, b, page, rowsPerPage)
            setData(data)
            setLoading(false)
        }
        getList()
    }, [q, b, page, rowsPerPage])
    useEffect(() => {
        const getBranch = async () => {
            const data = await getBranchList()
            setBranchs(data)
        }
        getBranch()
    }, [])
   
    return (
        <Page>
            <TitlePage title='รายการเมล็ดดิบ' action={
                <>
                    <AddButton link={'/stock/stock-raw/add'} />
                    {
                        profile?.BranchNo?.BranchNo === '00' &&
                        <Box className="col-lg-2 col-md-12 ">
                            <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                                <FormControl variant="standard" fullWidth >
                                    <Select value={b || 'all'}
                                        onChange={e => setSearchParams({ q: q, b: e.target.value })}
                                        disableUnderline
                                        MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                    >
                                        <MenuItem value='all'>ศูนย์ทั้งหมด</MenuItem>
                                        {branchs?.map((x, i) => (
                                            <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Box >
                    }
                    <Box className="col-lg-2 col-md-12 ">
                        <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                            <FormControl variant="standard" fullWidth >
                                <Select value={b || 'all'}
                                    onChange={e => setSearchParams({ q: q, b: e.target.value })}
                                    disableUnderline
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    <MenuItem value='all'>ประเภทเอกสารทั้งหมด</MenuItem>
                                    <MenuItem value='รับ'>รับ</MenuItem>
                                    <MenuItem value='จ่าย'>จ่าย</MenuItem>

                                </Select>
                            </FormControl>
                        </Box>
                    </Box >
                    <InputSearch value={q} onChange={e => setSearchParams({ q: e.target.value, b: b })} placeholder={"ค้นหา เลขที่เอกสาร"} />
                </>
            } />
            <div class="stockReceive  row">
                {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :

                    <div class="col-md-12 table-responsive-sm pb-3">
                        <table class="table table-borderless table-hover ">
                            <thead>
                                <tr>
                                    <th class="text-center">ที่</th>
                                    <th class="text-center">ศูนย์เมล็ดพันธุ์ข้าว</th>
                                    <th class="text-center">ประเภทเอกสาร</th>
                                    <th class="text-center">วันที่เอกสาร</th>
                                    <th class="text-center">เลขที่เอกสาร</th>
                                    <th class="text-center">ปริมาณ (กิโลกรัม)</th>
                                    <th class="text-center">สถานะ</th>
                                    <th class="text-center">ดำเนินการ</th>
                                </tr>
                            </thead>
                            <tbody class="">
                                {data?.items?.map((x, i) => (
                                    <tr className={id === x?.ReceiveNo ? 'active' : ''}>
                                        <td class="text-center">{(data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i}</td>
                                        <td class="text-center">{x?.BranchNo?.BranchName}</td>
                                        <td class="text-center">{x?.DocumentType}</td>
                                        <td class="text-center">{dayjs(x?.DocumentDate).format('DD/MM/BBBB')}</td>
                                        <td class="text-center">{x?.DocumentNo}</td>
                                        <td class="text-center">{x?.TotalQty?.toLocaleString()}</td>
                                        <td class="text-center">
                                            {x?.Status === 'C' ? <span class="status-draft">
                                                ปิด
                                            </span> :
                                                x?.Status === 'Y' ?
                                                    <span class="status-active">
                                                        เสร็จสิ้น
                                                    </span> : x?.Status === 'N' ?
                                                        <span class="status-inactive">
                                                            ยกเลิก
                                                        </span> : ''}

                                        </td>
                                        <td class="text-center">
                                            <Link to={`/stock/stock-raw/${x?.DocumentNo}`} onClick={() => setSearchParams({ id: x?.DocumentNo, page: page, q: q, b: b })}>
                                                <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>เรียกดู</Button>
                                            </Link>
                                        </td>
                                    </tr >
                                ))}

                            </tbody >
                        </table >
                    </div >}
                <div class="col-md-12 text-center mt-4">
                    <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={data?.meta?.totalPages} page={+page} onChange={(event, value) => setSearchParams({ page: value, q: q, b: b, id: id })} shape="rounded" />
                </div>
            </div >

        </Page>
    )
}
